import { render } from "./ProgramModal.vue?vue&type=template&id=5b1716a8&scoped=true"
import script from "./ProgramModal.vue?vue&type=script&lang=js"
export * from "./ProgramModal.vue?vue&type=script&lang=js"

import "./ProgramModal.vue?vue&type=style&index=0&id=5b1716a8&scoped=true&lang=scss"

import exportComponent from "C:\\projets\\rivha\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b1716a8"]])

export default __exports__